import React from 'react';
import SupervisorLayout from '../../components/SupervisorLayout';
import ReportRunner from '../../components/ReportRunner';
import './SupervisorGeneralReportPage.css';

const SupervisorGeneralReportPage = () => (
  <SupervisorLayout>
    <h2 className="svgr-title">Rapport général</h2>
    <ReportRunner
      endpoint="/reports/supervisor/"
      showCompanyGroupBy={false}
      showSupervisorGroupBy={false}
      showScopeFilter={false}
    />
  </SupervisorLayout>
);

export default SupervisorGeneralReportPage;
